import { Component, OnInit } from '@angular/core';
import { GoogleService, ModalService } from 'src/app/services';
import jsonData from '../../data/booths.json';
import { Welcome } from 'src/app/models';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
    public data: Welcome = jsonData.welcome;
    public yesHcp: boolean = false;
    public congressSelected: string = '';
    public selectEl: HTMLElement;

    constructor(
        private modalSvc: ModalService,
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
        this.selectEl = document.querySelector('.custom-select.congress');
    }

    public async answer(resp: string = 'no'): Promise<void> {
        if (resp === 'yes') {
            this.yesHcp = true;
        } else {
            this.googleSvc.sendGAEventById(2);
            window.location.href = 'https://www.bayer.com/en/';
            // this.modalSvc.setActiveModalById('thankyou');
        }
    }

    public onSelect(val: any): void {
        console.log('this.selectEl', this.selectEl);
        console.log('val.length', val.length);

        if (val.length >= 35) {
            this.selectEl.style.width = '42%';
        } else if (val.length < 35 && val.length >= 30) {
            this.selectEl.style.width = '40%';
        } else if (val.length < 30 && val.length >= 15) {
            this.selectEl.style.width = '30%';
        } else {
            this.selectEl.style.width = '20%';
        }

        this.congressSelected = val;

    }

    public onContinue(): void {
        const time = new Date().toISOString();
        localStorage.setItem(`${environment.showName}-gated`, time);
        localStorage.setItem(`${environment.showName}-show-name`, this.congressSelected);
        this.googleSvc.sendGAEventById(1, { label: this.congressSelected });
        this.modalSvc.hideModal();
    }
}
